const routes: {
  path: string;
  label?: string;
  footer?: boolean;
  show?: boolean;
}[] = [
  {
    path: '/about',
    label: 'About VisionHub',
    footer: true,
    show: true
  },
  {
    path: '/eyeglasses',
    label: 'Eyeglasses',
    footer: true,
    show: true
  },
  {
    path: '/highlights',
    label: 'Highlights',
    footer: true,
    show: true
  },
  {
    path: '/contactus',
    label: 'Contact Us',
    footer: true,
    show: true
  },
  {
    path: '/help',
    label: 'Help',
    footer: true,
    show: false
  },
  {
    path: '/favorites',
    label: 'My favorites',
    footer: true,
    show: false
  },
];

export default routes;
